(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      const details = [...root.querySelectorAll('details')];

      const sync = (item) => {
        const summary = item.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', String(item.open));
      };

      details.forEach((item) => {
        sync(item);
        item.addEventListener('toggle', () => sync(item));
      });

      root.addEventListener(
        'click',
        (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !root.contains(summary)) return;

          const item = summary.parentElement;
          if (!item || item.tagName !== 'DETAILS') return;

          event.preventDefault();
          item.open = !item.open;
          sync(item);
        },
        true
      );
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-nuances-faq]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trio-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.ready === 'true') return;

      const cards = [...root.querySelectorAll('[data-card]')];
      const count = root.querySelector('b[data-count]');
      const guide = root.querySelector('[data-guide]');
      const progress = root.querySelector('[data-progress]');
      const selection = root.querySelector('[data-selection]');
      const mobileSummary = root.querySelector('[data-mobile-summary]');
      const selectionDetails = root.querySelector('.trio-selection-details');
      const stepChoose = root.querySelector('[data-step-choose]');
      const stepCart = root.querySelector('[data-step-cart]');
      const submit = root.querySelector('[data-submit]');
      const form = root.querySelector('[data-trio-form]');
      const message = root.querySelector('[data-message]');

      if (!cards.length || !count || !guide || !progress || !selection || !mobileSummary || !selectionDetails || !stepChoose || !stepCart || !submit || !form || !message) return;

      root.dataset.ready = 'true';
      const storageKey = 'nuances-trio-selection-v1';
      let replacementId = null;

      if (window.matchMedia('(max-width: 749px)').matches) selectionDetails.open = false;

      const quantity = (card) => {
        const value = Number.parseInt(card.dataset.qty || '0', 10);
        return Number.isFinite(value) ? Math.max(0, Math.min(3, value)) : 0;
      };

      const total = () => cards.reduce((sum, card) => sum + quantity(card), 0);

      const persist = () => {
        const state = {};
        cards.forEach((card) => {
          const cardQuantity = quantity(card);
          if (cardQuantity > 0) state[card.dataset.id] = cardQuantity;
        });

        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      };

      const restore = () => {
        try {
          const state = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
          let restoredTotal = 0;

          cards.forEach((card) => {
            const savedQuantity = Number.parseInt(state[card.dataset.id] || '0', 10);
            const cardQuantity = Number.isFinite(savedQuantity)
              ? Math.max(0, Math.min(savedQuantity, 3 - restoredTotal))
              : 0;
            card.dataset.qty = String(cardQuantity);
            restoredTotal += cardQuantity;
          });
        } catch (error) {
          window.sessionStorage.removeItem(storageKey);
        }
      };

      const renderSelection = () => {
        const selectedCards = cards.filter((card) => quantity(card) > 0);
        selection.replaceChildren();

        if (!selectedCards.length) {
          const emptyItem = document.createElement('li');
          emptyItem.textContent = root.dataset.emptySelection;
          selection.appendChild(emptyItem);
          return;
        }

        selectedCards.forEach((card) => {
          const item = document.createElement('li');
          const label = document.createElement('span');
          label.textContent = `${card.dataset.title} × ${quantity(card)}`;
          const replace = document.createElement('button');
          replace.type = 'button';
          replace.dataset.replace = card.dataset.id;
          replace.textContent = root.dataset.replaceText;
          replace.setAttribute('aria-label', root.dataset.replaceLabel.replace('[product]', card.dataset.title));
          item.append(label, replace);
          selection.appendChild(item);
        });
      };

      const render = () => {
        const selectedTotal = total();
        const isComplete = selectedTotal === 3;
        const replacementCard = cards.find((card) => card.dataset.id === replacementId);
        const isReplacing = Boolean(replacementCard);

        count.textContent = root.dataset.count.replace('[count]', selectedTotal);
        mobileSummary.textContent = root.dataset.mobileSummary.replace('[count]', selectedTotal);
        guide.textContent = isReplacing
          ? root.dataset.replacing.replace('[product]', replacementCard.dataset.title)
          : isComplete
            ? root.dataset.complete
            : root.dataset.incomplete.replace('[count]', Math.max(0, 3 - selectedTotal));
        progress.style.transform = `scaleX(${Math.min(selectedTotal, 3) / 3})`;
        stepChoose.classList.toggle('is-active', !isComplete || isReplacing);
        stepCart.classList.toggle('is-active', isComplete && !isReplacing);
        submit.disabled = !isComplete || isReplacing;
        submit.setAttribute('aria-disabled', String(!isComplete || isReplacing));

        cards.forEach((card) => {
          const cardQuantity = quantity(card);
          const choice = card.querySelector('[data-select]');
          const minus = card.querySelector('[data-minus]');
          const plus = card.querySelector('[data-plus]');
          const output = card.querySelector('[data-qty]');
          const badge = card.querySelector('[data-card-badge]');

          card.dataset.qty = String(cardQuantity);
          if (output) output.textContent = String(cardQuantity);
          if (badge) badge.textContent = `×${cardQuantity}`;
          if (choice) {
            choice.disabled = isReplacing ? cardQuantity > 0 : selectedTotal >= 3 && cardQuantity === 0;
            choice.setAttribute('aria-pressed', String(cardQuantity > 0));
          }
          if (minus) minus.disabled = isReplacing || cardQuantity === 0;
          if (plus) plus.disabled = isReplacing || selectedTotal >= 3;
          card.classList.toggle('selected', cardQuantity > 0);
          card.classList.toggle('is-replacement-target', card === replacementCard);
        });

        renderSelection();
      };

      const addTrio = async () => {
        if (total() !== 3) {
          render();
          return;
        }

        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        const originalLabel = submit.textContent;
        submit.textContent = root.dataset.adding;
        message.textContent = '';

        const items = cards
          .filter((card) => quantity(card) > 0)
          .map((card) => ({
            id: Number(card.dataset.id),
            quantity: quantity(card),
            properties: { _offre: 'Trio Montréalais' },
          }));

        try {
          const cartBeforeResponse = await fetch(`${root.dataset.cartUrl}.js`, {
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!cartBeforeResponse.ok) throw new Error('Cart read failed');
          const cartBefore = await cartBeforeResponse.json();

          const response = await fetch(`${root.dataset.addUrl}.js`, {
            method: 'POST',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error('Trio add failed');

          const cartAfterResponse = await fetch(`${root.dataset.cartUrl}.js`, {
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!cartAfterResponse.ok) throw new Error('Cart verification failed');
          const cartAfter = await cartAfterResponse.json();

          if (Number(cartAfter.item_count) < Number(cartBefore.item_count) + 3) {
            throw new Error('Trio verification failed');
          }

          window.sessionStorage.removeItem(storageKey);
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          message.textContent = root.dataset.error;
          submit.textContent = originalLabel;
          render();
        }
      };

      root.addEventListener('click', (event) => {
        const replaceControl = event.target.closest('[data-replace]');
        if (replaceControl && root.contains(replaceControl)) {
          replacementId = replacementId === replaceControl.dataset.replace ? null : replaceControl.dataset.replace;
          message.textContent = '';
          render();
          return;
        }

        const control = event.target.closest('[data-select], [data-plus], [data-minus]');
        if (!control || !root.contains(control)) return;

        const card = control.closest('[data-card]');
        if (!card) return;

        event.preventDefault();
        event.stopPropagation();
        const currentQuantity = quantity(card);

        if (control.matches('[data-select]') && replacementId && currentQuantity === 0) {
          const replacementCard = cards.find((candidate) => candidate.dataset.id === replacementId);
          if (replacementCard) {
            replacementCard.dataset.qty = String(Math.max(0, quantity(replacementCard) - 1));
            card.dataset.qty = '1';
          }
          replacementId = null;
        } else if (control.matches('[data-select]') && currentQuantity === 0 && total() < 3) {
          card.dataset.qty = '1';
        }

        if (control.matches('[data-plus]') && total() < 3) {
          card.dataset.qty = String(currentQuantity + 1);
        }

        if (control.matches('[data-minus]')) {
          card.dataset.qty = String(Math.max(0, currentQuantity - 1));
        }

        message.textContent = '';
        persist();
        render();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        await addTrio();
      });

      window.addEventListener('pageshow', render);
      restore();
      render();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-trio-builder]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
